export default __webpack_public_path__ + "static/media/img10.f1b63d1b.jpg";